import { render, staticRenderFns } from "./PrintPosFaCiadeV1.vue?vue&type=template&id=a1be07a4&scoped=true"
import script from "./PrintPosFaCiadeV1.vue?vue&type=script&lang=js"
export * from "./PrintPosFaCiadeV1.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaCiadeV1.vue?vue&type=style&index=0&id=a1be07a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1be07a4",
  null
  
)

export default component.exports